









































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import BaseVue from '../../core/BaseVue';

@Component
export default class ResearchCenterBasicInformationComponent extends BaseVue {
  @Prop() readonly profilePicture!: any;
  @Prop() readonly fullName!: string;
  @Prop() readonly municipio!: string;
  @Prop() readonly provincia!: string;
  @Prop() readonly profile!: string;
  @Prop() readonly profilePictureCustomClass!: string;
  @Prop() readonly informationCustomClass!: string;
  @Prop() readonly informationCustomFormat!: string;
  @Prop() readonly informationCustomPadding!: string;
  @Prop() readonly profilePictureCustomPadding!: string;
  @Prop() readonly isSelection!: boolean;
  @Prop() readonly reduceFullName!: boolean;

  formatNombreInstitucion(nombre: string) {
    if (nombre.length > 70) {
      return nombre.substring(0, 60) + "...";
    }
    return nombre;
  }

}
